import Select, { SelectItem, SelectProps } from '../components/Select';
import { ProfileStatus } from '../common/interfaces/profile.interface';

const StatusOptions: SelectItem<string>[] = [
    {
        key: ProfileStatus.ACTIVE,
        value: 'Active'
    },
    {
        key: ProfileStatus.INACTIVE,
        value: 'Inactive'
    },
];

type ProfileStatusSelectProps = Omit<SelectProps<string>, 'options'>;

const ProfileStatusSelect = ({ selected, onChange, ...selectProps }: ProfileStatusSelectProps) => {
    return (
        <Select
            {...selectProps}
            placeholder={`Status`}
            options={StatusOptions}
            onChange={onChange}
            selected={selected}
        />
    );
};

export default ProfileStatusSelect;
